// Sample news data for testing when backend is down
export const sampleNewsData = {
  mint: [
    {
      _id: "1",
      title: "Reliance Industries Q3 profit rises 9% to Rs 19,641 crore",
      content:
        "Reliance Industries Ltd (RIL) on Friday reported a 9% year-on-year rise in consolidated net profit to Rs 19,641 crore for the quarter ended December 31, 2023. The company's revenue from operations increased 3.6% to Rs 2.48 lakh crore during the quarter. The oil-to-telecom conglomerate's EBITDA (earnings before interest, taxes, depreciation, and amortization) grew 16.7% to Rs 44,678 crore. The company's digital services business, Jio, reported a 12.3% rise in net profit to Rs 5,208 crore, while its retail business saw a 32% increase in net profit to Rs 3,165 crore.",
      name: "Reliance Industries",
      company: "Reliance Industries Ltd",
      source: "LiveMint",
      publishedDate: "2024-01-19",
      url: "https://www.livemint.com/companies/reliance-industries-q3-profit-rises-9-to-rs-19641-crore-11705567891234.html",
    },
    {
      _id: "2",
      title: "TCS reports 8.2% rise in Q3 net profit to Rs 11,058 crore",
      content:
        "Tata Consultancy Services (TCS) on Thursday reported an 8.2% year-on-year rise in consolidated net profit to Rs 11,058 crore for the quarter ended December 31, 2023. The company's revenue from operations increased 4% to Rs 60,583 crore during the quarter. TCS's operating margin expanded by 50 basis points to 25%. The company added 5,611 employees during the quarter, taking its total headcount to 603,305. TCS also declared an interim dividend of Rs 9 per share and a special dividend of Rs 18 per share.",
      name: "TCS",
      company: "Tata Consultancy Services Ltd",
      source: "LiveMint",
      publishedDate: "2024-01-18",
      url: "https://www.livemint.com/companies/tcs-reports-8-2-rise-in-q3-net-profit-to-rs-11058-crore-11705567891235.html",
    },
    {
      _id: "3",
      title: "HDFC Bank Q3 net profit rises 33.5% to Rs 16,372 crore",
      content:
        "HDFC Bank on Saturday reported a 33.5% year-on-year rise in standalone net profit to Rs 16,372 crore for the quarter ended December 31, 2023. The bank's net interest income (NII) increased 23.9% to Rs 28,471 crore during the quarter. The bank's gross non-performing assets (NPAs) ratio improved to 1.26% from 1.34% in the previous quarter. HDFC Bank's total advances grew 62.4% to Rs 24.69 lakh crore, while total deposits increased 27.7% to Rs 22.14 lakh crore.",
      name: "HDFC Bank",
      company: "HDFC Bank Ltd",
      source: "LiveMint",
      publishedDate: "2024-01-20",
      url: "https://www.livemint.com/companies/hdfc-bank-q3-net-profit-rises-33-5-to-rs-16372-crore-11705567891236.html",
    },
  ],
  bs: [
    {
      _id: "4",
      title: "Infosys Q3 results: Net profit up 7.3% to Rs 6,106 crore",
      content:
        "Infosys on Thursday reported a 7.3% year-on-year rise in consolidated net profit to Rs 6,106 crore for the quarter ended December 31, 2023. The company's revenue from operations increased 1.3% to Rs 38,821 crore during the quarter. Infosys's operating margin expanded by 50 basis points to 20.5%. The company reduced its headcount by 6,101 employees during the quarter, taking its total headcount to 322,663. Infosys also revised its revenue growth guidance for FY24 to 1.5-2% from 1-2.5%.",
      name: "Infosys",
      company: "Infosys Ltd",
      source: "Business Standard",
      publishedDate: "2024-01-18",
      url: "https://www.business-standard.com/article/companies/infosys-q3-results-net-profit-up-7-3-to-rs-6106-crore-124011800123_1.html",
    },
    {
      _id: "5",
      title: "Wipro Q3 net profit falls 12% to Rs 2,694 crore",
      content:
        "Wipro on Friday reported a 12% year-on-year decline in consolidated net profit to Rs 2,694 crore for the quarter ended December 31, 2023. The company's revenue from operations decreased 4.4% to Rs 22,205 crore during the quarter. Wipro's operating margin contracted by 100 basis points to 16%. The company reduced its headcount by 4,473 employees during the quarter, taking its total headcount to 240,234. Wipro expects revenue from IT services business to be in the range of $2.615 billion to $2.669 billion for the March quarter.",
      name: "Wipro",
      company: "Wipro Ltd",
      source: "Business Standard",
      publishedDate: "2024-01-19",
      url: "https://www.business-standard.com/article/companies/wipro-q3-net-profit-falls-12-to-rs-2694-crore-124011900123_1.html",
    },
  ],
  financial: [
    {
      _id: "6",
      title: "ITC Q3 net profit rises 6.6% to Rs 5,572 crore",
      content:
        "ITC Ltd on Monday reported a 6.6% year-on-year rise in standalone net profit to Rs 5,572 crore for the quarter ended December 31, 2023. The company's revenue from operations increased 2.1% to Rs 19,484 crore during the quarter. ITC's cigarette business revenue grew 3.8% to Rs 8,304 crore, while its FMCG business revenue increased 7.6% to Rs 5,209 crore. The company's hotels business revenue rose 15.2% to Rs 1,005 crore, while its paperboards business revenue grew 2.8% to Rs 2,267 crore.",
      name: "ITC",
      company: "ITC Ltd",
      source: "Financial Express",
      publishedDate: "2024-01-22",
      url: "https://www.financialexpress.com/companies/itc-q3-net-profit-rises-6-6-to-rs-5572-crore-3371234/",
    },
  ],
  economics: [
    {
      _id: "7",
      title: "HCL Tech Q3 net profit rises 6.2% to Rs 4,350 crore",
      content:
        "HCL Technologies on Thursday reported a 6.2% year-on-year rise in consolidated net profit to Rs 4,350 crore for the quarter ended December 31, 2023. The company's revenue from operations increased 6.1% to Rs 28,446 crore during the quarter. HCL Tech's operating margin expanded by 30 basis points to 19.8%. The company added 3,818 employees during the quarter, taking its total headcount to 225,944. HCL Tech expects revenue growth of 5-5.5% in constant currency for FY24.",
      name: "HCL Tech",
      company: "HCL Technologies Ltd",
      source: "Economic Times",
      publishedDate: "2024-01-18",
      url: "https://economictimes.indiatimes.com/tech/technology/hcl-tech-q3-net-profit-rises-6-2-to-rs-4350-crore/articleshow/107055678/show.cms",
    },
    {
      _id: "8",
      title: "Tech Mahindra Q3 net profit falls 60.6% to Rs 510 crore",
      content:
        "Tech Mahindra on Wednesday reported a 60.6% year-on-year decline in consolidated net profit to Rs 510 crore for the quarter ended December 31, 2023. The company's revenue from operations decreased 4.6% to Rs 13,101 crore during the quarter. Tech Mahindra's operating margin contracted by 300 basis points to 4.5%. The company reduced its headcount by 4,354 employees during the quarter, taking its total headcount to 146,250. Tech Mahindra expects the challenging environment to continue in the near term.",
      name: "Tech Mahindra",
      company: "Tech Mahindra Ltd",
      source: "Economic Times",
      publishedDate: "2024-01-17",
      url: "https://economictimes.indiatimes.com/tech/technology/tech-mahindra-q3-net-profit-falls-60-6-to-rs-510-crore/articleshow/107055679/show.cms",
    },
  ],
  moneycontrol: [
    {
      _id: "9",
      title: "Larsen & Toubro Q3 net profit rises 15.5% to Rs 2,947 crore",
      content:
        "Larsen & Toubro (L&T) on Tuesday reported a 15.5% year-on-year rise in consolidated net profit to Rs 2,947 crore for the quarter ended December 31, 2023. The company's revenue from operations increased 19% to Rs 55,128 crore during the quarter. L&T's order inflow grew 25% to Rs 75,990 crore during the quarter. The company's infrastructure segment revenue increased 21% to Rs 32,706 crore, while its energy segment revenue grew 15% to Rs 8,456 crore. L&T expects order inflow growth of 10-12% for FY24.",
      name: "L&T",
      company: "Larsen & Toubro Ltd",
      source: "Moneycontrol",
      publishedDate: "2024-01-23",
      url: "https://www.moneycontrol.com/news/business/companies/larsen-toubro-q3-net-profit-rises-15-5-to-rs-2947-crore-12345678.html",
    },
    {
      _id: "10",
      title: "Bharti Airtel Q3 net profit rises 54% to Rs 2,442 crore",
      content:
        "Bharti Airtel on Monday reported a 54% year-on-year rise in consolidated net profit to Rs 2,442 crore for the quarter ended December 31, 2023. The company's revenue from operations increased 5.8% to Rs 37,900 crore during the quarter. Airtel's average revenue per user (ARPU) increased 7.4% to Rs 208 during the quarter. The company's mobile data traffic grew 22.4% to 12,864 petabytes. Airtel's 4G customer base increased by 2.8 million to 204.6 million during the quarter.",
      name: "Bharti Airtel",
      company: "Bharti Airtel Ltd",
      source: "Moneycontrol",
      publishedDate: "2024-01-22",
      url: "https://www.moneycontrol.com/news/business/companies/bharti-airtel-q3-net-profit-rises-54-to-rs-2442-crore-12345679.html",
    },
  ],
};

// Helper function to get sample data for a specific source
export const getSampleNewsData = (source) => {
  return sampleNewsData[source] || [];
};

// Helper function to get sample count data
export const getSampleCountData = () => {
  return {
    lmCount: sampleNewsData.mint.length,
    bsCount: sampleNewsData.bs.length,
    feCount: sampleNewsData.financial.length,
    etCount: sampleNewsData.economics.length,
    mcCount: sampleNewsData.moneycontrol.length,
  };
};
